export default defineAppConfig({
    ui:{
        card:{
            header:{
                padding:"py-3"
            }
        }
    }
})